// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"styles_Tooltip__35pHM"};